
import * as Components from "./CoralCafe"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "coralcafe"
}

